import { CartAddEvent, ThemeEvents } from '@theme/events';

let navigatingToCart = false;

function destinationCartUrl() {
  const url = new URL(Theme.routes.cart_url, window.location.origin);
  const themePreview = new URL(window.location.href).searchParams.get('preview_theme_id');
  if (themePreview) url.searchParams.set('preview_theme_id', themePreview);
  return url;
}

document.addEventListener(ThemeEvents.cartUpdate, (event) => {
  const detail = event.detail;
  if (!detail || detail.data?.didError) return;

  const isAdd = event instanceof CartAddEvent || detail.data?.added === true;
  if (!isAdd) return;

  const total = detail.resource?.item_count;
  if (Number.isInteger(total) && total >= 0) {
    document.querySelectorAll('cart-icon').forEach((icon) => {
      if (typeof icon.renderCartBubble === 'function') {
        icon.renderCartBubble(total, false, false);
      }
    });
  }

  if (navigatingToCart) return;

  const destination = destinationCartUrl();
  if (window.location.pathname.replace(/\/$/, '') === destination.pathname.replace(/\/$/, '')) return;

  navigatingToCart = true;
  window.location.assign(destination.toString());
});
